import axios from 'axios'

const baseURL = import.meta.env.VITE_API_URL || ''

export const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000
})

// Pull JWT from localStorage if present.
api.interceptors.request.use((cfg) => {
  try {
    const token = localStorage.getItem('evoluxu_token')
    if (token && !cfg.headers.Authorization) {
      cfg.headers.Authorization = `Bearer ${token}`
    }
  } catch {}
  return cfg
})

// Normalize errors so callers see { status, message, raw }.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status ?? 0
    const message = err?.response?.data?.error ?? err?.response?.data?.message ?? err.message
    return Promise.reject({ status, message, raw: err })
  }
)

export function setToken(token) {
  try {
    if (token) localStorage.setItem('evoluxu_token', token)
    else localStorage.removeItem('evoluxu_token')
  } catch {}
}

export function getToken() {
  try { return localStorage.getItem('evoluxu_token') } catch { return null }
}
